import React, { useState, useEffect } from "react";
import { Select, MenuItem, FormControl } from "@mui/material";
import { getProductClass } from "../../../http/api/MasterAPI";

const ProductClassSelect = ({ onChange, value }) => {
  const [listProductClass, setListProductClass] = useState([]);
  const [selectedValue, setSelectedValue] = useState(value || null);

  async function getListProductClass() {
    try {
      const response = await getProductClass();
      const varList = response.masterVarInfo;
      const result = varList
        .map((element) => ({
          productclassId: element.varCd,
          productclassName: element.varValue1,
        }))
        .filter(
          (x) => x.productclassName && x.productclassName.trim() !== ""
        );
      setListProductClass(result);
    } catch (error) {
      console.error("担当者を取得するとき不具合発生した。", error);
    }
  }

  useEffect(() => {
    getListProductClass();
  }, []);

  useEffect(() => {
    setSelectedValue(value);
  }, [value]);

  const handleSelectionChange = (event) => {
    const newValue = event.target.value;
    setSelectedValue(newValue);
    if (onChange) {
      onChange(event);
    }
  };

  return (
    <>
      <Select
        value={selectedValue}
        onChange={handleSelectionChange}
        sx={{ width: 400 }}
      >
        <MenuItem key="unselected" value={null}>
          [未選択]
        </MenuItem>
        {listProductClass.map((item) => (
          <MenuItem
            key={item.productclassId}
            value={item.productclassId}
          >
            {item.productclassName}
          </MenuItem>
        ))}
      </Select>
    </>
  );
};

export default ProductClassSelect;
